<!--
  네비게이션
  미복구 이벤트 알람

  @since: 2019-11-05
  @updater: mk.ko
-->

<template>
  <li v-if="authAlarm"
      :class="`title dep-none navi-notice-group ${isShowNav ? '' : 'navi-notice-group-footer'} ${isAlertOn ? 'on': ''}`">
    <!-- Navigation Alarm Badge-Tooltip -->
    <div class="list-inline">
      <a href="javascript:;"
         ref="alarmAnchor"
         class="navi-notice alert-notice-cursor"
         @click="onShowAlarmTooltip"
         @mouseover="isAlertOn = true"
         @mouseleave="isAlertOn = false"
      >
        <div :class="['badge badge-lv1', {'active-new': alarmInfoCount > 0}]" :style="getAlertStyle"><span class="badge-text">{{ getAlertText }}</span></div>
        <div :class="['badge badge-lv2 badge-white', {'active-new': alarmInfoCount > 0}]"><span class="badge-text">{{ getAlertText }}</span></div>
        <div class="badge badge-lv3 badge-info" :style="getAlertStyle"><span class="badge-text">{{ getAlertText }}</span></div>
      </a>

      <a href="javascript:;"
         v-if="isShowNav"
         :style="iconTextStyle"
         class="alert-notice-cursor"
         @click="onShowAlarmTooltip"
         @mouseover="isAlertOn = true"
         @mouseleave="isAlertOn = false"
      >{{ $t('cmn.unrecoveryEvent') }}</a>

      <q-tooltip v-show="!showAlarmTooltip"
                 self="center left"
                 anchor="top right"
                 class="bs bs-q-tooltip bs-q-tooltip-default"
                 :offset="[5, 15]"
      >
        <!--<em>-->
          <!--{{ getAlertTooltip }}-->
        <!--</em>-->
        <template v-if="typeof alarmInfo === 'undefined'">
          <span>{{ $t('msg.mainNavigation_tooltip_noWarnLog') }}</span>
        </template>

        <template v-else>
          <span>{{ $t('da.viewIssueUpSummaryEventLog') }}</span>
        </template>

      </q-tooltip>

    </div>

    <div v-show="showAlarmTooltip"
         v-global-hide="onCloseAlarmTooltip">

      <template v-if="typeof alarmInfo !== 'undefined'">

        <div ref="alarmTooltip"
             class="q-tooltip animate-popup-up bs bs-q-tooltip bs-q-tooltip-default"
             style="z-index: 9999 !important;">

          <div class="marB5">

            <div class="inline-block">
              <span>{{ $t('msg.mainNavigation_tooltip_issueUpWarningLog') }}</span>
            </div>

            <q-btn flat round color="dark"
                   class="text-gray-volume"
                   :icon="toggleAlarmSound ? 'volume_up' : 'volume_off'"
                   size="sm"
                   @click="onToggleAlarmSound">
              <tool-tip :message="toggleAlarmSound ? $t('msg.turnOnAlarm') : $t('msg.turnOffAlarm')" />
            </q-btn>

            <q-btn @click="onClickShowAlertEventPopup" color="dark" flat="flat"
                   class="bs bs-q-btn-xs bs-q-btn-flat-type bs-q-btn-info-setup float-right">
              <!--장비 현황 보기-->
              <span class="bs-q-btn-text">{{$t('da.viewDeviceStatus')}}</span>
              <q-icon class="bs-q-btn-icon bs-q-btn-icon-info-setup"/>
            </q-btn>
          </div>

          <div>
            <div class="inline-block">
              <span class="f10">(<span class="textR">&#x25cf;</span>: {{$t('msg.newAlert')}})</span>
            </div>
          </div>

          <table class="bs-table table-box-type">
          <!--<table class="bs-table table-box-type th-gray">-->

            <colgroup>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
            </colgroup>

            <thead>
              <tr>
                <th>Total</th>
                <th v-for="(item, idx) in tooltipHeaderText">
                  <div class="inline-block">
                    <span>{{ item }}</span>
                    <sup v-if="alarmInfo.event_list[idx].new_cnt > 0" class="textR f10"> &#x25cf;</sup>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td class="table-cell-align-center" :title="alarmInfo.event_cnt">
                  {{ getScale(alarmInfo.event_cnt) }}
                </td>
                <td class="table-cell-align-center"
                    v-for="(item, idx) in alarmInfo.event_list"
                    :style="getLevelStyle(item.color)">
                  <div class="inline-block">
                    <span :title="(item.old_cnt + item.new_cnt)">{{ getScale(item.old_cnt + item.new_cnt) }}</span>
                    <span v-if="item.new_cnt" :title="item.new_cnt"> (+{{ getScale(item.new_cnt) }})</span>
                  </div>
                </td>
              </tr>
            </tbody>

          </table>

        </div>

      </template>

    </div>


    <!-- 외곽 가시 알림 -->
<!--    <template v-if="showBorderAlarm">-->
    <template v-if="false">
      <div class="page-alert page-alert-top" ref="alertLayout" :style="getAlertStyle"/>
      <div class="page-alert page-alert-right" ref="alertLayout" :style="getAlertStyle"/>
      <div class="page-alert page-alert-bottom" ref="alertLayout" :style="getAlertStyle"/>
      <div class="page-alert page-alert-left" ref="alertLayout" :style="getAlertStyle"/>
    </template>

    <!-- 알람 가청 -->
    <audio ref="alarmAudio" />

  </li>
</template>

<script>
  import { kmgtConverter, getColorLuminance } from '~/utils/charts'
  import { setToolTipPosition, parsePosition } from '~/utils/toolTipUtils'

  // plugins
  import Hub from '~/plugins/global-event-hub'

  import { createNamespacedHelpers } from 'vuex'
  const { mapState } = createNamespacedHelpers('common/navigation')
  // const { mapState: commonMapState, mapMutations: commonMapMutations, mapActions: commonMapActions } = createNamespacedHelpers('common/common/')
  const { mapState: commonMapState, mapActions: commonMapActions } = createNamespacedHelpers('common/common/')

  export default {
    name: 'NavigationAlarm',
    components: {},
    directives: {},
    mixins: [],
    props: {},
    data () {
      return {
        isAlertOn: false,
        checkAlertTimer: void 0,
        showBorderAlarm: false,
        tooltipHeaderText: ['Critical', 'High', 'Medium', 'Low', 'Info'],
        showAlarmTooltip: false,
        toggleAlarmSound: true
        // alertLevel: 'Info'
      }
    },
    computed: {
      ...mapState([
        'authAlarm'
      ]),
      ...commonMapState([
        'alarmInfo',
        'preventLogoutAfterTimer',
        'isShowNav'
      ]),
      isNewWindow () {
        return this.$route.query.newWindow
      },
      iconTextStyle () {
        try {
          let res = {}
          switch (_.get(String(this.getAlertText), ['length'], 0)) {
            case 1:
            case 2:
              res['padding-left'] = '10px !important'
              break
            case 3:
              res['padding-left'] = '15px !important'
              break
            case 4:
              res['padding-left'] = '21px !important'
              break
          }
          return res
        } catch (e) {
          return {}
        }
      },
      alarmInfoCount () {
        // 경고 알람 갯수
        const alarmInfoCount = (typeof this.alarmInfo === 'undefined') ? 0 : this.alarmInfo.event_cnt

        // // 10개 이상인 경우 10+, 이하면 갯수대로 리턴
        // return alarmInfoCount > 10 ? '10+' : alarmInfoCount
        // 10개 이상인 경우 10+, 이하면 갯수대로 리턴
        return alarmInfoCount
      },
      getAlertText () {
        return this.alarmInfoCount > 999 ? '999+' : this.alarmInfoCount
      },
      getAlertStyle () {
        try {
          let info, low, medium, high, critical, eventColor
          // 레벨 확인
          const eventList = this.alarmInfo.event_list
          critical = eventList[0]
          high = eventList[1]
          medium = eventList[2]
          low = eventList[3]
          info = eventList[4]

          // 레벨에 따른 Class 설정
          if (critical.old_cnt > 0 || critical.new_cnt > 0) {
            eventColor = critical.color
          } else if (high.old_cnt > 0 || high.new_cnt > 0) {
            eventColor = high.color
          } else if (medium.old_cnt > 0 || medium.new_cnt > 0) {
            eventColor = medium.color
          } else if (low.old_cnt > 0 || low.new_cnt > 0) {
            eventColor = low.color
          } else if (info.old_cnt > 0 || info.new_cnt > 0) {
            eventColor = info.color
          }

          return {
            'background-color': eventColor,
            color: getColorLuminance(eventColor)
          }
        } catch (e) {
          const infoColor = '#4491e7'
          return {
            'background-color': infoColor,
            color: getColorLuminance(infoColor)
          }
        }
      },
      isExistNew () {
        // return _.sum(_.map(alarmInfo.event_list, o => o.new_cnt)) > 0
        try {
          // return _.sum(_.map(this.alarmInfo.event_list, o => o.new_cnt)) > 0
          return _.sumBy(this.alarmInfo.event_list, o => o.new_cnt) > 0
        } catch (e) {
          return false
        }
      }
    },
    methods: {
      // ...commonMapMutations([
      //   'initAlarmInfo'
      // ]),
      ...commonMapActions([
        'getAlarmInfo'
      ]),
      movePage (path) {
        this.$emit('movePage', path)
      },
      /*
        이름: onClickShowAlertEventPopup
        설명: 클릭 시 경고 이벤트 팝업을 출력하고, 경고 이벤트 정보를 모두 초기화한다.
      */
      onClickShowAlertEventPopup () {
        // 경고 검색시간 파라미터 -> 맨 마지막 인덱스의 시간이 stime, 맨 처음 인덱스의 시간이 etime
        if (typeof this.alarmInfo !== 'undefined') {
          // const sTime = this.alarmInfo[this.alarmInfo.length - 1].time
          // const eTime = this.alarmInfo[0].time
          //
          // // 경고 알람 URI 정의
          // const alertLogURI = `logReport/log/warningLog?menuName=${this.$t('lr.logSettings_dataTable_alert')}&newWindow=true'`
          //
          // // 세션 등록
          // // 2018.11.08 김민수 - 다국어 코드 추가
          // sessionStorage.setItem('SESSION_STORAGE_SET_LANG', this.getCurrentLocale)
          // sessionStorage.setItem('SESSION_STORAGE_SET_TOKEN', this.authToken)
          // sessionStorage.setItem('SESSION_STORAGE_SET_ISSUE_DATE', this.authIssueDate)
          // sessionStorage.setItem('SESSION_STORAGE_SET_REFRESH_TOKEN', this.authRefreshToken)
          //
          // // 새창 열기
          // const newLogWindow = window.open(alertLogURI, '', 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=1400px,height=800px')
          //
          // // 새 윈도우 파라미터에 sTime / eTime 등록
          // newLogWindow.currentAgentTime = {
          //   sdate: sTime,
          //   edate: eTime
          // }
          //
          // // 새 윈도우 스토어에 추가
          // this.newWindows.push(newLogWindow)
          //
          // // 알람 요약 초기화
          // this.alertLevel = 'Info'
          //
          // // 모든 알람 초기화
          // this.initAlarmInfo()

          // 미복구 이벤트 (TAMS)
          const alertLogURI = '/dashboard/dashboard/deviceStatus'
          // this.$router.push(alertLogURI)
          this.movePage(alertLogURI)
          this.showAlarmTooltip = false

          // // const routeData = this.$router.resolve({
          // //   // name: this.$t('cmn.eventLog'),
          // //   name: 'eventLog',
          // //   query: {
          // //     menuName: 'logReport-prismLog-eventLog',
          // //     newWindow: true
          // //   }
          // // })
          //
          // // 2018.11.08 김민수 - 다국어 코드 추가
          // sessionStorage.setItem('SESSION_STORAGE_SET_LANG', this.getCurrentLocale)
          // sessionStorage.setItem('SESSION_STORAGE_SET_TOKEN', this.authToken)
          // sessionStorage.setItem('SESSION_STORAGE_SET_ISSUE_DATE', this.authIssueDate)
          // sessionStorage.setItem('SESSION_STORAGE_SET_REFRESH_TOKEN', this.authRefreshToken)
          //
          // const alertLogURI = `/logReport/prismLog/eventLog?menuName${this.$t('cmn.eventLog')}&newWindow=true&deviceTime=${this.agentTime}`
          // this.newWindows.push(window.open(alertLogURI, '', 'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=1400px,height=800px'))
        }
      },
      getScale (value) {
        return typeof value === 'number' ? kmgtConverter(value, 0) : 0
      },
      getLevelStyle (bgColor) {
        const background = bgColor
        const color = getColorLuminance(background)

        return {
          background,
          color
        }
      },
      /*
        이름: getAlertCss
        설명: 알람 정보를 기준으로 아이콘 스타일을 설정한다.
      */
      getAlertCss (animationLevel) {
        // Alert 메세지 중 가장 높은 레벨의 메세지 검색 (info, minor, major, critical)
        // let alertCss = 'badge-info'
        // let minor = 0, major = 0, critical = 0
        //
        // // 레벨 확인
        // for (const alertEvent of this.alarmInfo) {
        //   if (alertEvent.level) {
        //     switch (alertEvent.level.toLowerCase()) {
        //       case 'minor':
        //         minor++
        //         break
        //       case 'major':
        //         major++
        //         break
        //       case 'critical':
        //         critical++
        //         break
        //     }
        //   }
        // }
        //
        // // 레벨에 따른 Class 설정
        // if (critical > 0) {
        //   alertCss = 'badge-critical'
        //   this.alertLevel = 'Critical'
        // } else if (major > 0) {
        //   alertCss = 'badge-major'
        //   this.alertLevel = 'Major'
        // } else if (minor > 0) {
        //   alertCss = 'badge-minor'
        //   this.alertLevel = 'Minor'
        // }
        //
        // // 스타일 리턴
        // return `badge badge-lv${animationLevel} ${alertCss} ${animationLevel === 1 && this.alarmInfo.length > 0 ? 'active-new' : ''}`

        // let alarmInfoCount = 0
        // try {
        //   if (typeof this.alarmInfo !== 'undefined') {
        //     alarmInfoCount = this.alarmInfo.event_cnt || 0
        //   }
        // } catch (e) {
        //   alarmInfoCount = 0
        // }
        //
        // // info, low, medium, high, critical
        // if (typeof this.alarmInfo !== 'undefined') {
        //   const level = this.alarmInfo.event_level
        //   switch (level) {
        //     case 1:
        //       this.alertLevel = 'Info'
        //       break
        //     case 2:
        //       this.alertLevel = 'Low'
        //       break
        //     case 3:
        //       this.alertLevel = 'Medium'
        //       break
        //     case 4:
        //       this.alertLevel = 'High'
        //       break
        //     case 5:
        //       this.alertLevel = 'Critical'
        //       break
        //     default:
        //       this.alertLevel = 'Info'
        //   }
        //
        //   alarmInfoCount = this.alarmInfo.event_cnt
        // } else {
        //   this.alertLevel = 'Info'
        //   alarmInfoCount = 0
        // }

        return [ 'badge', `badge-lv${animationLevel}`, (this.alarmInfoCount > 0) ? 'badge-critical' : 'badge-info', { 'active-new': animationLevel === 1 && this.alarmInfoCount > 0 } ]
      },
      // TAMS
      setAlertTimer () {
        this.checkAlertTimer = setTimeout(this.detectAlarm, 60000)
      },
      stopAlertTimer () {
        if (typeof this.checkAlertTimer !== 'undefined') {
          clearTimeout(this.checkAlertTimer)
        }
      },
      async detectAlarm () {
        if (typeof this.checkAlertTimer !== 'undefined') {
          clearTimeout(this.checkAlertTimer)
        }

        await this.getAlarmInfo()

        // 가청 체크
        this.checkTurnOnAlarm()

        // 자동 세션 아웃 시간 만료 후 timer 호출 방지
        if (!this.preventLogoutAfterTimer) {
          this.setAlertTimer()
        } else {
          if (typeof this.checkAlertTimer !== 'undefined') {
            clearTimeout(this.checkAlertTimer)
          }
        }
      },
      checkTurnOnAlarm () {
        try {
          const audio = this.$refs.alarmAudio
          let showBorderAlarm = false
          if (this.alarmInfo.hasOwnProperty('event_sound_id')) {
            if (this.alarmInfo.event_sound_id !== null) {
              showBorderAlarm = true
              if (audio) {
                audio.src = `/api/sm/event-sound/${this.alarmInfo.event_sound_id}`
                if (this.toggleAlarmSound) {
                  audio.play()
                }
              }
            } else {
              showBorderAlarm = false
              if (_.get(audio, ['src'])) {
                audio.pause()
              }
            }
          } else {
            showBorderAlarm = false
            if (_.get(audio, ['src'])) {
              audio.pause()
            }
          }

          if (this.showBorderAlarm !== showBorderAlarm) {
            this.showBorderAlarm = showBorderAlarm
          }
        } catch (e) {
          this.$log('Navigation Alarm GUI Error (checkTurnOnAlarm)', e)
        }
      },
      onShowAlarmTooltip () {
        try {
          if (typeof this.alarmInfo !== 'undefined') {
            this.showAlarmTooltip = true
            this.$nextTick(() => {
              setToolTipPosition({
                el: this.$refs.alarmTooltip,
                animate: true,
                offset: [-40, 0],
                anchorEl: this.$refs.alarmAnchor,
                anchorOrigin: parsePosition('top left'),
                selfOrigin: parsePosition('bottom left')
              })
            })
          }
        } catch (e) {
          this.showAlarmTooltip = false
        }
      },
      onCloseAlarmTooltip () {
        this.showAlarmTooltip = false
      },
      onToggleAlarmSound () {
        this.toggleAlarmSound = !this.toggleAlarmSound

        if (this.$refs.alarmAudio.src) {
          if (!this.toggleAlarmSound) {
            this.$refs.alarmAudio.pause()
          } else {
            // ON 시 다음번 신규 경고 알람 발생 건 부터 알람 발생됨.
            // this.$refs.alarmAudio.play()
          }
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      window.addEventListener('resize', this.onCloseAlarmTooltip)
      window.addEventListener('scroll', this.onCloseAlarmTooltip)

      if (!this.isNewWindow) {
        this.$nextTick(() => {
          // 알람 이벤트 감지
          this.detectAlarm()

          // 설정 복구 도중, 전역 타이머 동작되지 않도록 타이머 관리열 추가
          Hub.addTimer('alarmTimer', {
            start: this.setAlertTimer,
            stop: this.stopAlertTimer
          })
        })
      }
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    beforeRouteLeave (to, from, next) {
      if (typeof this.checkAlertTimer !== 'undefined') {
        clearTimeout(this.checkAlertTimer)
      }
      window.removeEventListener('resize', this.onCloseAlarmTooltip)
      window.removeEventListener('scroll', this.onCloseAlarmTooltip)
      next()
    },
    destroyed () {},
    errorCaptured () {},
    watch: {}
  }
</script>

<style scoped>
  .alert-notice-cursor {
    cursor: pointer;
  }
  .table-cell-align-center {
    text-align: center
  }
  .badge-text {
    color: inherit !important;
  }

  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes flash {
    0% {opacity: 0.1}
    10% {opacity: 0.2}
    25% {opacity: 0.5}
    40% {opacity: 0.7}
    70% {opacity: 0.9}
    80% {opacity: 0.85}
    100% {opacity: 0.6}
  }

  /* Standard syntax */
  @keyframes flash {
    0% {opacity: 0.1}
    10% {opacity: 0.2}
    25% {opacity: 0.5}
    40% {opacity: 0.7}
    70% {opacity: 0.9}
    80% {opacity: 0.85}
    100% {opacity: 0.6}
  }

  /*TAMS 가시 알림*/
  .page-alert {
    position: fixed;
    z-index: 9999;
    -webkit-animation-name: flash;
    -webkit-animation-duration: 1.2s;
    -webkit-animation-iteration-count: infinite;
    animation-name: flash;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
  }
  .page-alert.page-alert-top {
    left: 0;
    top: 0;
    width: 100vw;

    height: 11px;
    /*height: 10px;*/
  }
  .page-alert.page-alert-right {
    right: 0;
    top: 11px;
    height: calc(100% - 22px);
    width: 11px;

    /*top: 10px;*/
    /*height: calc(100% - 20px);*/
    /*width: 10px;*/
  }
  .page-alert.page-alert-bottom {
    left: 0;
    bottom: 0;
    width: 100vw;

    height: 11px;
    /*height: 10px;*/
  }
  .page-alert.page-alert-left {
    left: 0;
    top: 11px;
    height: calc(100% - 22px);
    width: 11px;

    /*top: 10px;*/
    /*height: calc(100% - 20px);*/
    /*width: 10px;*/
  }
  .list-inline {
    display: inline !important;
  }
  .inline-block {
    display: inline-block !important;
  }
  .inline-block span {
    display: unset !important;
  }
  .text-gray-volume {
    color: #575757 !important;
  }
</style>


